import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';
import Button from '../Button';
import { PaymentMethodsEnum } from './payment-methods-enum';

const paymentSubtypes = [
  {
    key: 'visa',
    title: 'Visa',
    image: '/static/images/course/visa.png',
  },
  {
    key: 'mastercard',
    title: 'Mastercard',
    image: '/static/images/course/mastercard.jpg',
  },
  {
    key: 'americanexpress',
    title: 'American Express',
    image: '/static/images/course/americanexpress.png',
  },
];

const StripePayment = ({ orderCourse, orderLoading }) => (
  <div className={styles.paymantContainer}>
    {paymentSubtypes.map(payment => (
      <div className={styles.paymentType} key={payment.key}>
        <Button
          loading={orderLoading === `${PaymentMethodsEnum.STRIPE}-${payment.key}`}
          onClick={() => orderCourse(PaymentMethodsEnum.STRIPE, payment.key)}
        >
          <img src={payment.image} alt={payment.title} />
        </Button>

        <div>{payment.title}</div>
      </div>
    ))}
  </div>
);

StripePayment.propTypes = {
  orderLoading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  orderCourse: PropTypes.func.isRequired,
};

StripePayment.defaultProps = {
  orderLoading: false,
};

export default StripePayment;
